import React from 'react';
import LookupManager from '../components/LookupManager';
import { adminAPI } from '../services/adminApi';

const BodyParts = () => (
  <LookupManager
    title="Body Parts"
    subtitle="Manage your body parts"
    singularLabel="Body Part"
    searchPlaceholder="Search bodyparts…"
    fetchList={adminAPI.getBodyPartsAdmin}
    createItem={adminAPI.createBodyPart}
    updateItem={adminAPI.updateBodyPart}
  />
);

export default BodyParts;